import { loadSettings, saveSettings } from '@/config/localSettings';
import { create } from 'zustand';

import i18n from '@/i18n';
import type { LanguageType } from '@contiple/antd-ds';

interface LanguageState {
  language: LanguageType;
  setLanguage: (language: LanguageType) => void;
}

export const useLanguageStore = create<LanguageState>((set) => ({
  language: loadSettings().language,
  setLanguage: (language) => {
    i18n.changeLanguage(language);
    set({ language });
    saveSettings({ language });
  },
}));
